/* eslint-disable no-console */
import handleLogout from '@/components/MainHeader/utils/logout'
import { goToPhoneValidation } from '@/navigation/CSR/goToPhoneValidation'
import isSSR from '@/utils/isSSR'
import { onError as onErrorApollo } from '@apollo/client/link/error'
import { GraphQLError } from 'graphql'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import codeByMessage from './utils/codeByMessage'

type ErrorCallback = (error?: string) => void

const reportError = (error: GraphQLError) => {
  console.error(
    `[GraphQL error]: Message: ${error.message}, Location: ${JSON.stringify(
      error.locations
    )}, Path: ${error.path}`
  )
}

// TODO: move this to a helper
const extensionErrors = ({
  code,
  callback,
  router,
}: {
  code: unknown
  callback: ErrorCallback
  router?: AppRouterInstance
}) => {
  if (code === 'UNAUTHENTICATED' || code === 'UNAUTHORIZED') {
    console.log(
      '↔ ~ HANDLE Error: APOLLO_UNAUTHENTICATED_OR_UNAUTHORIZED',
      code
    )
    if (!isSSR()) {
      handleLogout()
    }
    callback(code)
    setTimeout(() => {
      if (!isSSR()) {
        window.location.href = '/'
      }
    }, 1500)
  }
  if (code === 'ENFORCE_CUSTOMER_PHONE_VALIDATION_FAILED' && router) {
    console.log('↔ ~ HANDLE Error : ENFORCE_CUSTOMER_PHONE_VALIDATION_FAILED')
    goToPhoneValidation(router)
  }
  return callback()
}

const onError = (errorCallback: ErrorCallback, router?: AppRouterInstance) =>
  onErrorApollo(({ graphQLErrors, networkError, operation, forward }) => {
    console.log('👹 ~ Error: APOLLO_ERROR_NAME', operation.operationName)
    console.log(
      '👹 ~ Error: APOLLO_ERROR_VARIABLES',
      JSON.stringify(operation.variables)
    )
    if (graphQLErrors) {
      graphQLErrors.forEach((err: GraphQLError) => {
        reportError(err)
        extensionErrors({
          code: codeByMessage(err) || err.extensions.code,
          callback: errorCallback,
          router: router,
        })
      })
      forward(operation)
    }
    if (networkError) {
      console.log(`👹 ~ Error: APOLLO_NETWORK_ERROR`, networkError) // TODO: Error handler when connection fails
    }
  })

export default onError
